// import React, { useState } from "react";
// import { Helmet } from "react-helmet-async";
// import { Link } from "react-router-dom";
// import FreeTrialModal from "./FreeTrialModal";
// import AOS from "aos";
// import "aos/dist/aos.css";
// import "animate.css";
// import logo1 from "../assets/logo1.png";

// const AiRecruiterPage = () => {
//   const [showTrial, setShowTrial] = useState(false);
//   return (
//     <>
//       {/* Navbar */}
//       <nav className="navbar navbar-expand-lg bg-white shadow-sm sticky-top">
//         <div className="container">
//           <Link className="navbar-brand mx-auto" to="/home">
//             <img src={logo1} alt="logo" style={{ height: "50px" }} />
//             <span className="web-name ms-2">Screenify</span>
//           </Link>

//           <button
//             className="navbar-toggler"
//             type="button"
//             data-bs-toggle="collapse"
//             data-bs-target="#navbarNav"
//           >
//             <span className="navbar-toggler-icon"></span>
//           </button>

//           <div
//             className="collapse navbar-collapse justify-content-between"
//             id="navbarNav"
//           >
//             <ul className="navbar-nav mx-auto">
//               <li className="nav-item">
//                 <Link className="nav-link" to="/">
//                   Home
//                 </Link>
//               </li>

//               <li className="nav-item">
//                 <Link className="nav-link" to="/about">
//                   About us
//                 </Link>
//               </li>

//               <li className="nav-item">
//                 <Link className="nav-link" to="/contact">
//                   Contact
//                 </Link>
//               </li>

//               <li className="nav-item">
//                 <Link className="nav-link" to="/blog">
//                   Blog
//                 </Link>
//               </li>

//               <li className="nav-item">
//                 <button
//                   className="btn btn-warning"
//                   onClick={() => setShowTrial(true)}
//                 >
//                   Free Trial
//                 </button>
//                 <FreeTrialModal
//                   show={showTrial}
//                   onClose={() => setShowTrial(false)}
//                 />
//               </li>
//             </ul>

//             <ul className="navbar-nav">
//               <li className="nav-item me-3">
//                 <Link className="btn btn-outline-primary" to="/login">
//                   Login
//                 </Link>
//               </li>
//               <li className="nav-item">
//                 <Link className="btn btn-outline-primary" to="/signup">
//                   Sign Up
//                 </Link>
//               </li>
//             </ul>
//           </div>
//         </div>
//       </nav>
//       <div className="container py-5">
//         {/* ================= SEO HELMET ================= */}
//         <Helmet>
//           <title>
//             AI Recruiter – AI Recruitment Tool for Smart Hiring | Screenify
//           </title>
//           <meta
//             name="description"
//             content="Screenify is an AI recruiter and AI recruitment tool that automates resume screening, candidate scoring, Document verification, and hiring workflows."
//           />
//           <meta
//             name="keywords"
//             content="AI recruiter, AI recruitment tool, AI hiring software, resume screening AI, automated hiring, HR automation"
//           />
//           <link rel="canonical" href="https://theairecruiter.ai/ai-recruiter" />
//         </Helmet>

//         {/* ================= HERO ================= */}
//         <section className="text-center mb-5">
//           <h1 className="fw-bold display-5">
//             AI Recruiter – Smart AI Recruitment Tool for Faster Hiring
//           </h1>
//           <p className="lead mt-3">
//             Screenify is an{" "}
//             <strong>AI Recruiter and AI Recruitment Tool</strong> that automates
//             resume screening, candidate validation, Document verification, and
//             hiring workflows — helping recruiters hire faster and smarter.
//           </p>
//         </section>

//         {/* ================= WHAT IS AI RECRUITER ================= */}
//         <section className="mb-5">
//           <h2 className="fw-bold">What Is an AI Recruiter?</h2>
//           <p>
//             An <strong>AI Recruiter</strong> is an intelligent hiring system
//             that uses artificial intelligence to analyze resumes, match
//             candidates with job descriptions, score profiles, and provide clear
//             hiring recommendations.
//           </p>
//           <ul>
//             <li>Skills and experience relevance</li>
//             <li>Job description alignment</li>
//             <li>Education and background validation</li>
//             <li>Overall candidate suitability</li>
//           </ul>
//         </section>

//         {/* ================= HOW IT WORKS ================= */}
//         <section className="mb-5">
//           <h2 className="fw-bold">How Screenify AI Recruiter Works</h2>

//           <h5>1. Upload Job Description</h5>
//           <p>Define required skills, experience, and qualifications.</p>

//           <h5>2. AI Resume Screening</h5>
//           <p>AI scans resumes instantly and extracts key candidate data.</p>

//           <h5>3. Candidate Scoring & Validation</h5>
//           <p>
//             Each candidate receives an AI-generated score with a
//             <strong> human-like validation reason</strong>.
//           </p>

//           <h5>4. Document verification (BGV)</h5>
//           <p>Automated employment, education, and identity checks.</p>

//           <h5>5. Shortlist & Hire Faster</h5>
//           <p>Get ranked shortlists for faster hiring decisions.</p>
//         </section>

//         {/* ================= WHY SCREENIFY ================= */}
//         <section className="mb-5">
//           <h2 className="fw-bold">
//             Why Choose Screenify as Your AI Recruiter?
//           </h2>
//           <ul>
//             <li>
//               <strong>10x Faster Hiring</strong> – Reduce manual screening
//             </li>
//             <li>
//               <strong>Accurate Candidate Matching</strong>
//             </li>
//             <li>
//               <strong>Bias-Free Screening</strong>
//             </li>
//             <li>
//               <strong>Automated Document verification</strong>
//             </li>
//             <li>
//               <strong>Human-Like Validation Reasons</strong>
//             </li>
//             <li>
//               <strong>Scalable for Any Team Size</strong>
//             </li>
//           </ul>
//         </section>

//         {/* ================= COMPARISON ================= */}
//         <section className="mb-5">
//           <h2 className="fw-bold">AI Recruiter vs Traditional Recruitment</h2>

//           <div className="table-responsive">
//             <table className="table table-bordered mt-3">
//               <thead>
//                 <tr>
//                   <th>Traditional Hiring</th>
//                   <th>Screenify AI Recruiter</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 <tr>
//                   <td>Manual resume screening</td>
//                   <td>Automated AI resume screening</td>
//                 </tr>
//                 <tr>
//                   <td>Slow shortlisting</td>
//                   <td>Instant candidate ranking</td>
//                 </tr>
//                 <tr>
//                   <td>Inconsistent evaluations</td>
//                   <td>Standardized AI scoring</td>
//                 </tr>
//                 <tr>
//                   <td>Separate BGV process</td>
//                   <td>Integrated Document verification</td>
//                 </tr>
//               </tbody>
//             </table>
//           </div>
//         </section>

//         {/* ================= USE CASES ================= */}
//         <section className="mb-5">
//           <h2 className="fw-bold">Use Cases</h2>

//           <h5>For HR Teams</h5>
//           <p>Automate bulk hiring and reduce recruiter workload.</p>

//           <h5>For Recruitment Agencies</h5>
//           <p>Screen thousands of resumes and deliver quality shortlists.</p>

//           <h5>For Startups</h5>
//           <p>Hire faster with limited HR resources.</p>

//           <h5>For Enterprises</h5>
//           <p>Scale hiring with consistency and compliance.</p>
//         </section>

//         {/* ================= FAQ ================= */}
//         <section className="mb-5">
//           <h2 className="fw-bold">Frequently Asked Questions</h2>

//           <h6>What does Screenify’s AI recruiter evaluate?</h6>
//           <p>
//             Skills, experience, education, JD relevance, and background
//             verification.
//           </p>

//           <h6>How accurate is AI resume screening?</h6>
//           <p>
//             Our AI is trained on real hiring data to deliver explainable
//             results.
//           </p>

//           <h6>Does Screenify replace human recruiters?</h6>
//           <p>No, it assists recruiters by automating repetitive tasks.</p>

//           <h6>Is Screenify suitable for small teams?</h6>
//           <p>Yes, Screenify scales from startups to enterprises.</p>
//         </section>

//         {/* ================= CTA ================= */}
//         <section className="text-center">
//           <h2 className="fw-bold">Start Hiring Smarter with an AI Recruiter</h2>
//           <p className="lead">
//             Screen resumes instantly, validate candidates accurately, and hire
//             with confidence.
//           </p>

//           <button
//             className="btn btn-success btn-lg"
//             onClick={() => setShowTrial(true)}
//           >
//             Start Free Trial
//           </button>
//           <FreeTrialModal
//             show={showTrial}
//             onClose={() => setShowTrial(false)}
//           />
//         </section>
//       </div>
//       {/* Contact Info Cards */}
//       <section className="py-5 bg-dark">
//         <div className="container text-center text-white">
//           <h2
//             className="fw-bold display-5"
//             data-aos="fade-up"
//             data-aos-delay="300"
//           >
//             Get in Touch
//           </h2>
//           <p className="mb-4" data-aos="fade-up" data-aos-delay="300">
//             We’d love to hear from you! Reach out with any questions or
//             feedback.
//           </p>

//           <div
//             className="row g-4 justify-content-center"
//             style={{ borderBottom: "2px solid rgba(255, 255, 255, 0.3)" }}
//           >
//             {[
//               {
//                 title: "Call Us",
//                 icon: "fas fa-phone-alt",
//                 lines: ["+91 96115 12281", "+91 90083 09255"],
//                 color: "text-primary",
//               },
//               {
//                 title: "Email",
//                 icon: "fas fa-envelope",
//                 lines: ["contactus@archipeltechnologies.com"],
//                 color: "text-warning",
//               },
//               {
//                 title: "Follow Us",
//                 icon: "fas fa-share-alt",
//                 social: true,
//               },
//             ].map((item, i) => (
//               <div
//                 className="col-md-4 mb-3"
//                 key={i}
//                 data-aos="fade-up"
//                 data-aos-delay={i * 200}
//               >
//                 <div
//                   className="p-4 rounded-4 shadow text-center hover-scale"
//                   style={{
//                     background: "rgba(255, 255, 255, 0.1)",
//                     backdropFilter: "blur(10px)",
//                   }}
//                 >
//                   <i className={`${item.icon} fa-3x mb-3 ${item.color}`}></i>
//                   <h5 className="fw-bold mb-3">{item.title}</h5>

//                   {item.social ? (
//                     <div>
//                       <a href="#" className="me-3">
//                         <i className="fab fa-linkedin fa-2x text-primary"></i>
//                       </a>
//                       <a href="#" className="me-3">
//                         <i
//                           className="fab fa-instagram fa-2x"
//                           style={{ color: "#E4405F" }}
//                         ></i>
//                       </a>
//                       <a href="#">
//                         <i className="fab fa-youtube fa-2x text-danger"></i>
//                       </a>
//                     </div>
//                   ) : (
//                     item.lines.map((line, idx) => (
//                       <p key={idx} className="mb-1">
//                         {item.icon === "fas fa-envelope" ? (
//                           <a
//                             href={`mailto:${line}`}
//                             className="text-decoration-none text-white"
//                           >
//                             <i className={`${item.icon} me-2 text-warning`}></i>
//                             {line}
//                           </a>
//                         ) : (
//                           <a
//                             href={`tel:${line}`}
//                             className="text-decoration-none text-white"
//                           >
//                             <i className={`${item.icon} me-2 text-primary`}></i>
//                             {line}
//                           </a>
//                         )}
//                       </p>
//                     ))
//                   )}
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* Footer */}
//       <footer
//         className="bg-white text-dark py-3"
//       >
//         <div className="container d-flex flex-column flex-lg-row justify-content-between align-items-center text-center">
//           <p className="mb-0">
//             © 2025 Archipel Technologies Pvt Ltd. All Rights Reserved.
//           </p>
//           <div>
//             <Link className="text-dark me-3" to="/privacy-policy">
//               Privacy & Cookies
//             </Link>
//             <Link className="text-dark" to="/terms-and-conditions">
//               Terms of Use
//             </Link>
//           </div>
//         </div>
//       </footer>

//       {/* Extra CSS */}
//       <style>{`
//         .hover-scale:hover {
//           transform: translateY(-6px);
//           transition: 0.3s;
//         }
//       `}</style>
//     </>
//   );
// };

// export default AiRecruiterPage;

import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import FreeTrialModal from "./FreeTrialModal";
import AOS from "aos";
import "aos/dist/aos.css";
import "animate.css";
import logo1 from "../assets/logo1.png";

const AiRecruiterPage = () => {
  const [showTrial, setShowTrial] = useState(false);

  useEffect(() => {
    AOS.init({ once: true, duration: 800, easing: "ease-out-cubic" });
  }, []);

  return (
    <>
      {/* ================= NAVBAR ================= */}
      <nav className="navbar navbar-expand-lg bg-white shadow-sm sticky-top">
        <div className="container">
          <Link className="navbar-brand mx-auto" to="/">
            <img
              src={logo1}
              alt="Screenify logo"
              loading="lazy"
              style={{ height: "50px" }}
            />
            <span className="web-name ms-2">Screenify</span>
          </Link>

          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarNav"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          <div
            className="collapse navbar-collapse justify-content-between"
            id="navbarNav"
          >
            <ul className="navbar-nav mx-auto">
              <li className="nav-item">
                <Link className="nav-link" to="/">
                  Home
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  className="nav-link active fw-semibold"
                  to="/ai-recruiter"
                >
                  AI Recruiter
                </Link>
              </li>

              <li className="nav-item">
                <Link className="nav-link" to="/about">
                  About Us
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/contact">
                  Contact
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/blog">
                  Blog
                </Link>
              </li>
              {/* <li className="nav-item">
                <button
                  className="btn btn-warning ms-lg-3"
                  onClick={() => setShowTrial(true)}
                >
                  Free Trial
                </button>
              </li> */}
            </ul>

            <ul className="navbar-nav ms-lg-auto mt-3 mt-lg-0 text-center">
              <li className="nav-item mb-2 mb-lg-0 me-lg-2">
                <button
                  className="btn btn-warning w-100 w-lg-auto"
                  onClick={() => setShowTrial(true)}
                >
                  Free Trial
                </button>
                <FreeTrialModal
                  show={showTrial}
                  onClose={() => setShowTrial(false)}
                />
              </li>

              <li className="nav-item mb-2 mb-lg-0 me-lg-2">
                <Link
                  className="btn btn-outline-primary w-100 w-lg-auto"
                  to="/login"
                >
                  Login
                </Link>
              </li>

              <li className="nav-item">
                <Link
                  className="btn btn-outline-primary w-100 w-lg-auto"
                  to="/signup"
                >
                  Sign Up
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </nav>

      {/* ================= SEO ================= */}
      <Helmet>
        <title>
          AI Recruiter – AI Recruitment Tool for Smart Hiring | Screenify
        </title>
        <meta
          name="description"
          content="Screenify is an AI-powered recruitment platform for resume screening, candidate evaluation, document management, and structured onboarding workflows.."
        />
        <meta
          name="keywords"
          content="AI recruiter, AI recruitment tool, AI hiring software, resume screening AI, automated hiring"
        />
        <link rel="canonical" href="https://theairecruiter.ai/ai-recruiter" />

        {/* Open Graph */}
        <meta
          property="og:title"
          content="AI Recruiter – AI Recruitment Tool | Screenify"
        />
        <meta
          property="og:description"
          content="Hire faster using Screenify AI Recruiter with automated resume screening and candidate validation."
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content="https://theairecruiter.ai/ai-recruiter"
        />

        {/* FAQ Schema */}
        <script type="application/ld+json">
          {`
          {
            "@context": "https://schema.org",
            "@type": "FAQPage",
            "mainEntity": [
              {
                "@type": "Question",
                "name": "What does Screenify’s AI recruiter evaluate?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "Skills, experience, education, job description relevance, and Document verification."
                }
              },
              {
                "@type": "Question",
                "name": "How accurate is AI resume screening?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "Screenify uses AI trained on real hiring data to deliver explainable and consistent results."
                }
              }
            ]
          }
        `}
        </script>
      </Helmet>

      {/* ================= HERO ================= */}
      <section
        className="text-center hero text-white"
        style={{
          background: "linear-gradient(135deg, #007bff, #00c6ff)",
          padding: "100px 0",
          position: "relative",
          overflow: "hidden",
        }}
      >
        <div className="container" data-aos="fade-up">
          <h1 className="fw-bold display-5 animate__animated animate__fadeInUp">
            AI Recruiter – Smart AI Recruitment Tool for Faster Hiring
          </h1>
          <p className="lead mt-3 animate__animated animate__fadeInUp">
            Screenify is an{" "}
            <strong>AI Recruiter and AI Recruitment Tool</strong> that assists
            recruiters with resume screening, candidate evaluation, document
            verification, and structured onboarding workflows.
          </p>

          <button
            className="btn btn-light btn-lg me-3 shadow animate__animated animate__fadeInUp"
            onClick={() => setShowTrial(true)}
          >
            Start Free Trial
          </button>
        </div>
      </section>
      <div className="container py-3">
        {/* ================= WHAT IS ================= */}
        <section className="mb-5" data-aos="fade-up">
          <h2 className="fw-bold">What Is an AI Recruiter?</h2>
          <p>
            An <strong>AI Recruiter</strong> uses artificial intelligence to
            analyze resumes, match candidates with job descriptions, and provide
            clear hiring recommendations.
          </p>
          <ul>
            <li>Skills & experience relevance</li>
            <li>JD alignment</li>
            <li>Education & background verification</li>
            <li>Overall candidate suitability</li>
          </ul>
        </section>

        {/* ================= HOW IT WORKS ================= */}
        <section className="mb-5" data-aos="fade-up">
          <h2 className="fw-bold">How Screenify AI Recruiter Works</h2>

          <h5>1. Upload Job Description</h5>
          <p>Define required skills and qualifications.</p>

          <h5>2. AI Resume Screening</h5>
          <p>
            Our{" "}
            <Link to="/blog/how-ai-resume-screening-works-2025">
              AI resume screening
            </Link>{" "}
            instantly analyzes resumes.
          </p>

          <h5>3. Candidate Scoring & Validation</h5>
          <p>Each profile receives a human-like validation reason.</p>

          <h5>4. Document verification</h5>
          <p>Employment, education, and identity checks.</p>

          <h5>5. Shortlist & Hire Faster</h5>
          <p>Ranked candidates for faster decisions.</p>
        </section>

        {/* ================= COMPARISON ================= */}
        <section className="mb-5" data-aos="fade-up">
          <h2 className="fw-bold">AI Recruiter vs Traditional Recruitment</h2>
          <div className="table-responsive">
            <table
              className="table table-bordered mt-3"
              aria-label="AI recruiter comparison table"
            >
              <thead>
                <tr>
                  <th>Traditional Hiring</th>
                  <th>Screenify AI Recruiter</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Manual screening</td>
                  <td>Automated AI screening</td>
                </tr>
                <tr>
                  <td>Slow shortlisting</td>
                  <td>Instant ranking</td>
                </tr>
                <tr>
                  <td>Inconsistent evaluation</td>
                  <td>Standardized AI scoring</td>
                </tr>
                <tr>
                  <td>Separate BGV</td>
                  <td>Integrated BGV</td>
                </tr>
              </tbody>
            </table>
          </div>
        </section>

        {/* ================= CTA ================= */}
        <section className="text-center mt-5" data-aos="fade-up">
          <h2 className="fw-bold">Start Hiring Smarter with AI</h2>
          <p className="lead">
            Screen resumes instantly and hire with confidence.
          </p>
          <button
            className="btn btn-success btn-lg"
            onClick={() => setShowTrial(true)}
          >
            Start Free Trial
          </button>
        </section>
      </div>

      {/* Contact Info Cards */}
      <section className="py-5 bg-dark">
        <div className="container text-center text-white">
          <h2
            className="fw-bold display-5"
            data-aos="fade-up"
            data-aos-delay="300"
          >
            Get in Touch
          </h2>
          <p class="mb-4" data-aos="fade-up" data-aos-delay="300">
            We’d love to hear from you! Reach out with any questions or
            feedback.
          </p>

          <div
            className="row g-4 justify-content-center"
            style={{ borderBottom: "2px solid rgba(255, 255, 255, 0.3)" }}
          >
            {[
              {
                title: "Call Us",
                icon: "fas fa-phone-alt",
                lines: ["+91 96115 12281", "+91 90083 09255"],
                color: "text-primary",
              },
              {
                title: "Email",
                icon: "fas fa-envelope",
                lines: ["contactus@archipeltechnologies.com"],
                color: "text-warning",
              },
              {
                title: "Follow Us",
                icon: "fas fa-share-alt",
                social: true,
              },
            ].map((item, i) => (
              <div
                className="col-md-4 mb-3"
                key={i}
                data-aos="fade-up"
                data-aos-delay={i * 200}
              >
                <div
                  className="p-4 rounded-4 shadow text-center hover-scale"
                  style={{
                    background: "rgba(255, 255, 255, 0.1)",
                    backdropFilter: "blur(10px)",
                  }}
                >
                  <i className={`${item.icon} fa-3x mb-3 ${item.color}`}></i>
                  <h5 className="fw-bold mb-3">{item.title}</h5>

                  {item.social ? (
                    <div>
                      <a href="#" className="me-3">
                        <i className="fab fa-linkedin fa-2x text-primary"></i>
                      </a>
                      <a href="#" className="me-3">
                        <i
                          className="fab fa-instagram fa-2x"
                          style={{ color: "#E4405F" }}
                        ></i>
                      </a>
                      <a href="#">
                        <i className="fab fa-youtube fa-2x text-danger"></i>
                      </a>
                    </div>
                  ) : (
                    item.lines.map((line, idx) => (
                      <p key={idx} className="mb-1">
                        {item.icon === "fas fa-envelope" ? (
                          <a
                            href={`mailto:${line}`}
                            className="text-decoration-none text-white"
                          >
                            <i className={`${item.icon} me-2 text-warning`}></i>
                            {line}
                          </a>
                        ) : (
                          <a
                            href={`tel:${line}`}
                            className="text-decoration-none text-white"
                          >
                            <i className={`${item.icon} me-2 text-primary`}></i>
                            {line}
                          </a>
                        )}
                      </p>
                    ))
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer
        className="bg-white text-dark py-3"
        // style={{
        //   background: "linear-gradient(90deg, #007bff, #00c6ff)",
        // }}
      >
        <div className="container d-flex flex-column flex-lg-row justify-content-between align-items-center text-center">
          <p className="mb-0">
            © Copyright {new Date().getFullYear()} Archipel Technlogies Pvt Ltd.
            . All Rights Reserved.
          </p>
          <div>
            <Link className="text-dark me-3" to="/privacy-policy">
              Privacy & Cookies
            </Link>
            <Link className="text-dark" to="/terms-and-conditions">
              Terms of Use
            </Link>
          </div>
        </div>
      </footer>

      {/* ================= MODAL ================= */}
      <FreeTrialModal show={showTrial} onClose={() => setShowTrial(false)} />

      {/* ================= EXTRA CSS ================= */}
      <style>{`
        .hover-scale:hover {
          transform: translateY(-6px);
          transition: 0.3s;
        }
      `}</style>
    </>
  );
};

export default AiRecruiterPage;
